// #region Imports
//Components
import { defineComponent, defineAsyncComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-number-field',
    mixins: [appHost.mixins.form],
    components: {
        DxNumberBox: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dxCommon"*/ 'devextreme-vue/number-box')).DxNumberBox;
        }),
    },
    props: {
        placeholder: {
            type: String,
            required: false,
            default: ''
        },
        inputAttr: {
            type: Object,
            required: false,
            default: null,
        },
        largeSpin: {
            type: Boolean,
            required: false,
            default: false
        },
        showSpinButton: {
            type: Boolean,
            required: false,
            default: true
        },
        showClearButton: {
            type: Boolean,
            required: false,
            default: false
        },
        decimalPlaces: {
            type: Number,
            required: false,
            default: null
        },
        step: {
            type: Number,
            required: false,
            default: 1
        },
        mode: {
            type: String,
            required: false,
            default: null
        },
        minValue: {
            type: Number,
            required: false,
            default: null
        },
        maxValue: {
            type: Number,
            required: false,
            default: null
        },
    },
    data: () => ({
        dataType: 'number'
    }),
    computed: {
        inputAttrInternal() {
            return this.inputAttr;
        },
        isDisabled() {
            return this.readOnly;
        },
        numberFormat() {
            if (!this.decimalPlaces) {
                return null;
            }
            else {
                return { type: 'fixedPoint', precision: this.decimalPlaces };
            }
        }
    },
    methods: {
        onEnterKey(event) {
            this.$emit('EnterKey', event);
        },
        numberBoxValueChanged(e) {
            if (!this.mode || this.mode != "02") {
                return;
            }
            if (this.step === 0) {
                return;
            }
            if (this.showClearButton && !e.value) {
                return;
            }
            let tNewValue = this.round(e.value, this.step);
            if (this.maxValue > 0 && tNewValue > this.maxValue) {
                tNewValue = this.maxValue;
            }
            if (this.minValue > 0 && tNewValue < this.minValue) {
                tNewValue = this.minValue;
            }
            if (tNewValue !== e.value) {
                this.$refs.txtInput.instance.option('value', tNewValue);
            }
        },
        round(num, pre) {
            return pre * Math.ceil(num / pre);
        }
    }
});
// #endregion
